
import React from 'react';
import { useTranslation } from 'react-i18next';

const PractitionersHeader: React.FC = () => {
  const { t } = useTranslation('practitioners');

  return (
    <div className="text-center mb-8 opacity-0 animate-fade-in" style={{ animationDelay: '200ms' }}>
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-earth-900 mb-4 leading-tight">
        {t('findYourPractitioner')}
      </h1>
      <p className="text-xl text-earth-700 max-w-2xl mx-auto leading-relaxed">
        {t('findYourPractitionerSubtitle')}
      </p>
    </div>
  );
};

export default PractitionersHeader;
